function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_257",
  "data-name": "Rectangle 257",
  width: 120,
  height: 51.422,
  transform: "translate(0 0)",
  fill: "none"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "icon_-_return_box",
  "data-name": "icon - return box",
  transform: "translate(62 4)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_223",
  "data-name": "Rectangle 223",
  width: 64,
  height: 64,
  transform: "translate(-6 -4)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_95",
  "data-name": "Group 95",
  transform: "translate(-62 1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_94",
  "data-name": "Group 94",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2520",
  "data-name": "Path 2520",
  d: "M18.323,22.465a25.4,25.4,0,0,0,4.482-.643c2.012-.529,2.349-2.613,1.015-3.372,0,0-6.63-.585-9.2-.591a6.755,6.755,0,0,0-4.445,2.154,1.788,1.788,0,0,1-1.576.508l-4.864-.857a1.453,1.453,0,0,0-1.685,1.18L1.036,26.589a1.453,1.453,0,0,0,1.179,1.685l4.976.878a1.786,1.786,0,0,1,1.3,1.006,6.352,6.352,0,0,0,4.618,3.652l11.353,2",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2521",
  "data-name": "Path 2521",
  d: "M24.287,36.81l-11.352-2a7.339,7.339,0,0,1-5.359-4.217.779.779,0,0,0-.561-.442l-4.976-.877a2.47,2.47,0,0,1-2-2.859l1.013-5.745a2.475,2.475,0,0,1,2.859-2l4.864.858a.773.773,0,0,0,.681-.225,7.792,7.792,0,0,1,5.155-2.452h.01c2.585.006,9.017.57,9.289.595a1,1,0,0,1,.412.128,2.55,2.55,0,0,1,1.288,2.59A3.249,3.249,0,0,1,23.063,22.8a26.239,26.239,0,0,1-4.694.676,1.014,1.014,0,0,1-.094-2.026,24.494,24.494,0,0,0,4.273-.611c.708-.186,1.008-.61,1.051-.945a.534.534,0,0,0-.141-.46c-1.271-.109-6.637-.558-8.842-.563H14.61a5.827,5.827,0,0,0-3.719,1.855,2.8,2.8,0,0,1-2.47.791l-4.863-.857a.442.442,0,0,0-.512.357L2.033,26.765a.443.443,0,0,0,.359.511l4.975.877a2.808,2.808,0,0,1,2.042,1.572,5.337,5.337,0,0,0,3.878,3.087l11.352,2Z",
  fill: "#414143"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2522",
  "data-name": "Path 2522",
  d: "M51.1,46.548,16.283,40.41a1.588,1.588,0,0,1-1.288-1.839l4.418-25.056L57.352,20.2,52.933,45.26A1.587,1.587,0,0,1,51.1,46.548",
  fill: "#c7c7c7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2523",
  "data-name": "Path 2523",
  d: "M51.376,47.586a2.633,2.633,0,0,1-.458-.04L16.107,41.408A2.6,2.6,0,0,1,14,38.4l4.418-25.057a1.011,1.011,0,0,1,1.174-.822l37.938,6.69a1.017,1.017,0,0,1,.654.417,1,1,0,0,1,.167.758L53.931,45.437a2.6,2.6,0,0,1-2.555,2.149m-31.14-32.9L15.993,38.747a.574.574,0,0,0,.466.665L51.271,45.55a.575.575,0,0,0,.665-.466l4.242-24.058Z",
  fill: "#414143"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2524",
  "data-name": "Path 2524",
  d: "M57.351,20.2l-37.939-6.69.52-2.945a1.587,1.587,0,0,1,1.839-1.288l34.812,6.139a1.586,1.586,0,0,1,1.287,1.838Z",
  fill: "#c7c7c7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2525",
  "data-name": "Path 2525",
  d: "M57.352,21.218a1.075,1.075,0,0,1-.177-.015l-37.938-6.69a1.012,1.012,0,0,1-.822-1.174l.519-2.945a2.6,2.6,0,0,1,3.013-2.11L56.76,14.422a2.606,2.606,0,0,1,2.11,3.012l-.521,2.947a1.013,1.013,0,0,1-1,.837M20.587,12.693,56.529,19.03l.344-1.947a.575.575,0,0,0-.466-.665L21.595,10.28a.563.563,0,0,0-.429.1.573.573,0,0,0-.237.371Z",
  fill: "#414143"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2526",
  "data-name": "Path 2526",
  d: "M12.858,25.355s4.134.668,5.464-2.89A26.323,26.323,0,0,0,23.846,22c2.011-.528,2.349-2.612,1.014-3.371,0,0-7.67-.769-10.242-.775",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2527",
  "data-name": "Path 2527",
  d: "M13.66,26.428a6.1,6.1,0,0,1-.963-.072,1.014,1.014,0,0,1,.319-2c.135.021,3.339.477,4.358-2.244a.969.969,0,0,1,.969-.658,25.432,25.432,0,0,0,5.246-.427c.708-.186,1.008-.61,1.051-.945a.536.536,0,0,0-.144-.464c-1.369-.134-7.653-.738-9.88-.743a1.014,1.014,0,0,1,0-2.027h0c2.591.006,10.027.747,10.342.779a1.011,1.011,0,0,1,.4.128,2.552,2.552,0,0,1,1.289,2.59A3.253,3.253,0,0,1,24.1,22.986a24.013,24.013,0,0,1-5.126.5,5.817,5.817,0,0,1-5.318,2.947",
  fill: "#414143"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2528",
  "data-name": "Path 2528",
  d: "M53.858,40.015,38,37.219a.951.951,0,0,1-.771-1.1l1.807-10.247a.95.95,0,0,1,1.1-.771l15.86,2.8Z",
  fill: "#0ff497"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2529",
  "data-name": "Path 2529",
  d: "M53.86,41.028a1.067,1.067,0,0,1-.177-.015l-15.86-2.8a1.962,1.962,0,0,1-1.591-2.274l1.806-10.248A1.964,1.964,0,0,1,40.312,24.1l15.86,2.8a1.014,1.014,0,0,1,.822,1.175L54.857,40.191a1.013,1.013,0,0,1-1,.837M39.96,26.1l-1.733,10.2,14.81,2.55,1.785-10.126Z",
  fill: "#414143"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2530",
  "data-name": "Path 2530",
  d: "M99.826,18.783,72.768,24.037V43.91a1.094,1.094,0,0,0,.774,1.046l17.594,5.381a1.636,1.636,0,0,0,.792.042L118.1,45.3a1.094,1.094,0,0,0,.885-1.074V25.252a1.092,1.092,0,0,0-.773-1.045l-17.6-5.382a1.634,1.634,0,0,0-.792-.042",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2531",
  "data-name": "Path 2531",
  d: "M91.618,51.422a2.661,2.661,0,0,1-.778-.116L73.246,45.925a2.1,2.1,0,0,1-1.491-2.015V24.037a1.013,1.013,0,0,1,.82-1l27.058-5.254a2.631,2.631,0,0,1,1.283.068l17.6,5.381A2.1,2.1,0,0,1,120,25.252V44.223a2.111,2.111,0,0,1-1.705,2.069L92.122,51.374a2.68,2.68,0,0,1-.5.048M73.782,24.873V43.91l17.651,5.458a.625.625,0,0,0,.3.016L117.909,44.3l.064-.079V25.252l-17.651-5.458a.6.6,0,0,0-.3-.016h0Zm26.045-6.09h0Z",
  fill: "#414143"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2532",
  "data-name": "Path 2532",
  d: "M100.228,18.7,72.769,24.037V7.015a1.094,1.094,0,0,1,.885-1.073L98.926,1.034a1.094,1.094,0,0,1,1.3,1.074Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2533",
  "data-name": "Path 2533",
  d: "M72.768,25.05a1.013,1.013,0,0,1-1.013-1.013V7.015a2.109,2.109,0,0,1,1.707-2.069L98.733.039a2.108,2.108,0,0,1,2.509,2.068V18.7a1.014,1.014,0,0,1-.821,1l-27.46,5.332a1.042,1.042,0,0,1-.193.018M98.926,1.034l.193,1L73.847,6.936a.08.08,0,0,0-.065.079V22.808l25.432-4.939V2.107Zm1.3,17.671h0Z",
  fill: "#414143"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_23",
  "data-name": "Line 23",
  x1: 14.118,
  y2: 2.741,
  transform: "translate(89.848 23.072)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2534",
  "data-name": "Path 2534",
  d: "M89.847,26.827a1.013,1.013,0,0,1-.192-2.008l14.118-2.741a1.013,1.013,0,1,1,.386,1.989L90.041,26.808a.989.989,0,0,1-.194.019",
  fill: "#414143"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_24",
  "data-name": "Line 24",
  x1: 18.759,
  y1: 5.738,
  transform: "translate(72.768 24.037)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2535",
  "data-name": "Path 2535",
  d: "M91.528,30.789a1.024,1.024,0,0,1-.3-.045l-18.76-5.738a1.013,1.013,0,0,1,.594-1.938l18.76,5.738a1.014,1.014,0,0,1-.3,1.983",
  fill: "#414143"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2536",
  "data-name": "Path 2536",
  d: "M91.527,50.255V29.775l26.558-5.157",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2537",
  "data-name": "Path 2537",
  d: "M91.528,51.269a1.014,1.014,0,0,1-1.014-1.014V29.776a1.014,1.014,0,0,1,.821-.995l26.557-5.157a1.013,1.013,0,1,1,.386,1.989l-25.736,5V50.255a1.014,1.014,0,0,1-1.014,1.014",
  fill: "#414143"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2538",
  "data-name": "Path 2538",
  d: "M97.728,28.59V49.252l15.978-3.1V25.487Z",
  fill: "#0ff497"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2539",
  "data-name": "Path 2539",
  d: "M97.727,50.266a1.015,1.015,0,0,1-1.013-1.014V28.59a1.013,1.013,0,0,1,.82-1l15.979-3.1a1.015,1.015,0,0,1,1.207,1V46.15a1.014,1.014,0,0,1-.821.995l-15.979,3.1a.964.964,0,0,1-.193.019m1.014-20.84v18.6l13.952-2.709v-18.6Z",
  fill: "#414143"
}))));

function SvgIconReturnbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 64,
    viewBox: "0 0 120 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReturnbox);
export default __webpack_public_path__ + "static/media/icon-returnbox.defebdf6.svg";
export { ForwardRef as ReactComponent };